/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

/**
 * @author stcatai Jun 3, 2024
 */
export enum RequestType {
  SEARCH_MODELS = "SEARCH_MODELS",
  SEARCH_COMMITS = "SEARCH_COMMITS",
  ADD_MODEL = "ADD_MODEL",
  UPDATE_MODEL = "UPDATE_MODEL",
  REMOVE_MODEL = "REMOVE_MODEL",
  ADD_ANTISIGNATURE = "ADD_ANTISIGNATURE",
  REMOVE_ANTISIGNATURE = "REMOVE_ANTISIGNATURE",
  UPDATE_ANTISIGNATURE = "UPDATE_ANTISIGNATURE",
  SEARCH_ANTISIGNATURES = "SEARCH_ANTISIGNATURES"
}